import GeneratedPropertyStore from "./generated/GeneratedPropertyStore"

class PropertyStore extends GeneratedPropertyStore {

}

export const propertyStore = new PropertyStore()
